import { Card, FormGroup } from '../ui/Card';
import { detectCounty } from '../../lib/mn-data';
import type { CalculatorInputs } from '../../lib/types';

interface Props {
  inputs: CalculatorInputs;
  updateInput: <K extends keyof CalculatorInputs>(key: K, value: CalculatorInputs[K]) => void;
  collapsible?: boolean;
  summary?: string;
  isOpen?: boolean;
  onToggle?: () => void;
}

export function AddressCard({ inputs, updateInput, collapsible, summary, isOpen, onToggle }: Props) {
  const detection = detectCounty(inputs.propertyAddress, inputs.propertyCity, inputs.propertyZip);
  const hasInput = inputs.propertyAddress || inputs.propertyCity || inputs.propertyZip;

  return (
    <Card title="Property Address" collapsible={collapsible} summary={summary} isOpen={isOpen} onToggle={onToggle}>
      <div className="form-group full" style={{ marginBottom: '0.75rem' }}>
        <label>Street Address</label>
        <input
          type="text"
          placeholder="123 Main St"
          value={inputs.propertyAddress}
          onChange={e => updateInput('propertyAddress', e.target.value)}
        />
      </div>
      <div className="form-row">
        <FormGroup label="City">
          <input
            type="text"
            placeholder="Minneapolis"
            value={inputs.propertyCity}
            onChange={e => updateInput('propertyCity', e.target.value)}
          />
        </FormGroup>
        <FormGroup label="ZIP Code">
          <input
            type="text"
            placeholder="55401"
            value={inputs.propertyZip}
            onChange={e => updateInput('propertyZip', e.target.value)}
            maxLength={5}
          />
        </FormGroup>
      </div>
      {hasInput && detection && (
        <div className="address-detected">
          <span className="detect-icon">📍</span>
          <span>Detected: {detection.countyName} County — Property tax rate set to {detection.taxRate}%</span>
        </div>
      )}
      {hasInput && !detection && (
        <div className="address-detected" style={{ background: '#fefce8', borderColor: '#fde68a', color: '#854d0e' }}>
          <span className="detect-icon">📍</span>
          <span>County not auto-detected. Select manually below.</span>
        </div>
      )}
    </Card>
  );
}
